/* eslint-disable import/no-duplicates */
import React, { useEffect, useRef, useCallback, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { format, parseISO } from 'date-fns';

import { Container, Button, Row, Col } from 'react-bootstrap';

import api from '../../../services/api';

import { formatPrice, TIPO_USUARIO } from '../../../utils/funcoes';

import { useToast } from '../../../hooks/toast';
import { useClinica } from '../../../hooks/clinica';
import { useAuth } from '../../../hooks/auth';

import Input from '../../../components/Input';
import Select from '../../../components/Select';
import Loading from '../../../components/Loading';
import PageInfo from '../../../components/PageInfo';

import getValidationErrors from '../../../utils/getValidationErrors';

import HeaderRelatorio from '../HeaderRelatorio';
import getResponseErrors from '../../../utils/getResponseErrors';

interface IUsuariosNomeCodigo {
  UsuNome: string;
  // UsuCodigo: Number;
}

interface IRelatorio extends IUsuariosNomeCodigo {
  ConPerfil: string;
  valor: number;
  qtd: number;
  ticket: number;
}

interface IColuna {
  nome: string;
  valor: string;
  valorNumero: number;
  qtd: number;
  ticket: string;
}

interface IRelatorioFormatado {
  nome: string;
  colunas: IColuna[];
}

interface IDataBusca {
  dataInicio: string;
  dataFim: string;
}

interface IFormBusca {
  dataInicio: Date;
  dataFim: Date;
  CliCodigo: string;
  UsuCodigo: string;
}

interface IDataExibe {
  dataHora: string;
  dataDiaSemana: string;
}

const ProdutividadeExames: React.FC = () => {
  const history = useHistory();
  const { addToast } = useToast();
  const { user } = useAuth();
  const { optionsClinica } = useClinica();

  useEffect(() => {
    if (user.UsuTipo > TIPO_USUARIO.SUPERVISOR) {
      history.push('/sempermissao');
    }
  }, [history, user.UsuTipo]);

  const informacoesPagina = `<b>Descrição:</b> Exibe a quantidade de operações que os colaboradores realizaram no sistema, quantos agendamentos, quantas operações com cartão saúde (inclusões, exclusões, alteração de vencimento entre outras), quantas cobranças foram realizadas e quantos recebimentos foram feitos. `;

  const formRefBusca = useRef<FormHandles>(null);
  const [loading, setLoading] = useState(false);
  const [dadosRelatorio, setDadosRelatorio] = useState<IRelatorioFormatado[]>();

  const initialData = {
    dataInicio: format(new Date(), 'yyyy-MM-dd'),
    dataFim: format(new Date(), 'yyyy-MM-dd'),
    CliCodigo: user.UsuClinica.toString(),
  };
  const [dataExibe, setDataExibe] = useState<IDataExibe>();
  const [dataBusca, setDataBusca] = useState<IDataBusca>();
  const [clinica, setClinica] = useState('');

  const handleSubmitBusca = useCallback(
    async (dados: IFormBusca) => {
      setLoading(true);
      try {
        formRefBusca.current?.setErrors({});
        const schema = Yup.object().shape({
          dataInicio: Yup.date().required(),
          dataFim: Yup.date().required(),
          CliCodigo: Yup.string().nullable(true),
          UsuCodigo: Yup.string().nullable(true),
        });

        await schema.validate(dados, {
          abortEarly: false,
        });

        setClinica(
          optionsClinica.find(cli => cli.value === dados.CliCodigo)?.label ||
            '',
        );

        const dataInicioSelecionada = parseISO(dados.dataInicio.toString());
        const dataFimSelecionada = parseISO(dados.dataFim.toString());

        const dataInicioFormatada = format(dataInicioSelecionada, 'yyyy-MM-dd');
        const dataFimFormatada = format(dataFimSelecionada, 'yyyy-MM-dd');

        setDataBusca({
          dataInicio: dataInicioFormatada,
          dataFim: dataFimFormatada,
        });

        let parametrosOpcionais = dados.UsuCodigo
          ? `&UsuCodigo=${dados.UsuCodigo}`
          : '';
        parametrosOpcionais += dados.CliCodigo
          ? `&CliCodigo=${dados.CliCodigo}`
          : '';

        const response = await api.get<IRelatorio[]>(
          `/relatorios/produtividadeExames?dataInicio=${dataInicioFormatada}&dataFim=${dataFimFormatada}${parametrosOpcionais}`,
        );

        const perfil = response.data.map(rel => rel.ConPerfil);

        const perfis = new Set(perfil);

        const usuNome = response.data.map(rel => rel.UsuNome);

        const nomes = new Set(usuNome);

        const dadosFormatados: IRelatorioFormatado[] = [];
        let nomeAtual = '';

        nomes.forEach(nome => {
          const colunas: IColuna[] = [];
          if (nomeAtual !== nome) {
            nomeAtual = nome;
          }
          perfis.forEach(perf => {
            const dado = response.data.find(
              linha => linha.UsuNome === nome && linha.ConPerfil === perf,
            );
            if (dado)
              colunas.push({
                nome: perf,
                valorNumero: dado.valor,
                valor: formatPrice(parseFloat(dado.valor.toFixed(2))).replace(
                  'R$',
                  '',
                ),
                qtd: dado.qtd,
                ticket: formatPrice(
                  parseFloat((dado.valor / dado.qtd).toFixed(2)),
                ).replace('R$', ''),
              });
            if (!dado)
              colunas.push({
                nome: perf,
                valorNumero: 0,
                valor: '0,00',
                qtd: 0,
                ticket: '0,00',
              });
          });

          const TotalPorNome = colunas.reduce((tot, item) => {
            return tot + Number(item.valorNumero || 0);
          }, 0);

          dadosFormatados.push({
            nome,
            colunas: colunas.concat({
              nome: 'Total',
              valorNumero: TotalPorNome,
              valor: formatPrice(parseFloat(TotalPorNome.toFixed(2))).replace(
                'R$',
                '',
              ),
              qtd: 0,
              ticket: '0,00',
            }),
          });
        });

        // colunas.push({
        //   nome: perf,
        //   valor: formatPrice(parseFloat(dado.valor.toFixed(2))).replace(
        //     'R$',
        //     '',
        //   ),
        //   qtd: dado.qtd,
        //   ticket: formatPrice(
        //     parseFloat((dado.valor / dado.qtd).toFixed(2)),
        //   ).replace('R$', ''),
        // });

        setDataExibe({
          dataDiaSemana: `${format(
            dataInicioSelecionada,
            'dd/MM/yyyy',
          )} até ${format(dataFimSelecionada, 'dd/MM/yyyy')}`,
          dataHora: format(new Date(), 'dd/MM/yyyy HH:mm:ss'),
        });

        // const total: IRelatorio = {
        //   UsuNome: 'TOTAL',
        //   ConPerfil: '',
        //   valor: response.data.reduce((tot, item) => {
        //     return tot + Number(item.valor);
        //   }, 0),
        //   qtd: response.data.reduce((tot, item) => {
        //     return tot + Number(item.qtd);
        //   }, 0),
        //   ticket: response.data.reduce((tot, item) => {
        //     return tot + Number(item.ticket);
        //   }, 0),
        // };

        // const retorno = response.data.concat([total]);

        setDadosRelatorio(dadosFormatados);
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRefBusca.current?.setErrors(errors);
        } else {
          const mensagem = getResponseErrors(error);
          addToast({
            type: 'error',
            title: 'Não foi possível carregar dados',
            description: mensagem,
          });
        }
      } finally {
        setLoading(false);
      }
    },
    [addToast, optionsClinica],
  );

  const gerarTableHead = useCallback((colunas: IColuna[]) => {
    return (
      <>
        <tr>
          <th rowSpan={2} style={{ textAlign: 'center' }}>
            NOME
          </th>
          {colunas.map(colun => {
            return (
              <th
                colSpan={colun.nome === 'Total' ? 1 : 3}
                style={{ maxWidth: '170px', textAlign: 'center' }}
              >
                {colun.nome}
              </th>
            );
          })}
        </tr>
        <tr>
          {colunas.map(colun => {
            return (
              <>
                <th style={{ minWidth: '60px', textAlign: 'center' }}>Valor</th>
                {colun.nome !== 'Total' && (
                  <th style={{ minWidth: '50px', textAlign: 'center' }}>Qtd</th>
                )}
                {colun.nome !== 'Total' && (
                  <th style={{ minWidth: '60px', textAlign: 'center' }}>
                    Ticket
                  </th>
                )}
              </>
            );
          })}
        </tr>
      </>
    );
  }, []);

  const gerarTableLine = useCallback((linha: IRelatorioFormatado) => {
    return (
      <>
        <tr>
          <td style={{ minWidth: '180px' }}>{linha.nome}</td>
          {linha.colunas.map(colun => {
            return (
              <>
                <td align="center">{colun.valor}</td>
                {colun.nome !== 'Total' && <td align="center">{colun.qtd}</td>}
                {colun.nome !== 'Total' && (
                  <td align="center">{colun.ticket}</td>
                )}
              </>
            );
          })}
        </tr>
      </>
    );
  }, []);

  return (
    <Container fluid className="mt-2">
      {loading && <Loading />}
      <>
        <div className="d-print-none bg-white border p-2 mb-2">
          <div className="p-2 mb-2 d-flex justify-content-between">
            <h2 id="topoBusca">Produtividade Exames Antecipado</h2>{' '}
            <PageInfo
              descricao={informacoesPagina}
              permissao={TIPO_USUARIO.SUPERVISOR}
            />
          </div>
          {optionsClinica.length > 0 && user && (
            <Form
              ref={formRefBusca}
              initialData={initialData}
              onSubmit={handleSubmitBusca}
            >
              <Row>
                <Col md={3}>
                  <Input name="dataInicio" label="De" type="date" required />
                </Col>
                <Col md={3}>
                  <Input name="dataFim" label="Até" type="date" required />
                </Col>
                <Col md={3}>
                  <Select
                    name="CliCodigo"
                    label="Clinica"
                    options={optionsClinica}
                    disabled={user.UsuTipo !== TIPO_USUARIO.ADMINISTRADOR}
                  />
                </Col>
                <Col md={3}>
                  <br />
                  <Button type="submit" size="sm" variant="outline-secondary">
                    BUSCAR
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </div>

        <HeaderRelatorio
          dataImpressao={dataExibe?.dataHora}
          titulo={`PRODUTIVIDADE EXAMES ANTECIPADO${
            clinica.length > 0 ? `- ${clinica} -` : '-'
          } ${dataExibe?.dataDiaSemana || ''}`}
        />

        <div className="bg-white border p-2">
          {dadosRelatorio && dadosRelatorio.length > 0 && (
            <>
              <table
                className="table table-hover table-sm table-font-small table-bordered table-responsive"
                style={{ borderWidth: '0px' }}
              >
                <thead>{gerarTableHead(dadosRelatorio[0].colunas)}</thead>
                <tbody>
                  {dadosRelatorio &&
                    dadosRelatorio.map(rel => gerarTableLine(rel))}
                </tbody>
              </table>
            </>
          )}
        </div>
      </>
    </Container>
  );
};

export default ProdutividadeExames;
